import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store/store";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "layout-view",
    redirect: "/order",
    children: [
      {
        path: "/home",
        name: "home-view",
        meta: {
          title: "首页",
        },
        component: () => import("@/views/index/Home.vue"),
      },

      {
        path: "/redirect",
        name: "redirect-page",
        meta: {
          title: "重定向",
        },
        component: () => import("@/views/basedata/Redirect.vue"),
      },

      {
        path: "/measurement",
        name: "measurement",
        meta: {
          title: "基本单位",
        },
        component: () => import("@/views/basedata/Measurement.vue"),
      },
      {
        path: "/assist",
        name: "assist",
        meta: {
          title: "辅助单位",
        },
        component: () => import("@/views/basedata/AssistUnit.vue"),
      },
      {
        path: "/supplier",
        name: "supplier",
        meta: {
          title: "供应商",
        },
        component: () => import("@/views/basedata/Supplier.vue"),
      },
      {
        path: "/warehouse",
        name: "warehouse",
        meta: {
          title: "仓库",
        },
        component: () => import("@/views/basedata/Warehouse.vue"),
      },
      {
        path: "/location",
        name: "location",
        meta: {
          title: "货位",
        },
        component: () => import("@/views/basedata/Location.vue"),
      },
      {
        path: "/area",
        name: "area",
        meta: {
          title: "货区",
        },
        component: () => import("@/views/basedata/Area.vue"),
      },

      {
        path: "/category",
        name: "category",
        meta: {
          title: "商品分类",
        },
        component: () => import("@/views/basedata/ProductCategory.vue"),
      },
      {
        path: "/brand",
        name: "brand",
        meta: {
          title: "商品品牌",
        },
        component: () => import("@/views/basedata/ProductBrand.vue"),
      },

      {
        path: "/platform",
        name: "platform",
        meta: {
          title: "平台货品",
        },
        component: () => import("@/views/goods/Platform.vue"),
      },
      {
        path: "/goodFiles",
        name: "good-files",
        meta: {
          title: "货品档案",
        },
        component: () => import("@/views/goods/GoodFiles.vue"),
      },
      {
        path: "/code",
        name: "code",
        meta: {
          title: "SKU&商家编码",
        },
        component: () => import("@/views/goods/Code.vue"),
      },
      {
        path: "/single",
        name: "single",
        meta: {
          title: "单品列表",
        },
        component: () => import("@/views/goods/Single.vue"),
      },
      {
        path: "/suit",
        name: "suit",
        meta: {
          title: "套装列表",
        },
        component: () => import("@/views/goods/Suit.vue"),
      },
      {
        path: "/statistics",
        name: "statistics",
        meta: {
          title: "商品销售统计",
        },
        component: () => import("@/views/goods/Statistics.vue"),
      },
      {
        path: "/outboundOrder",
        name: "outbound-order",
        meta: {
          title: "出库单",
        },
        component: () => import("@/views/outboundOrder/OutboundOrder.vue"),
      },
      {
        path: "/shop",
        name: "shop",
        meta: {
          title: "店铺列表",
        },
        component: () => import("@/views/shop/ShopList.vue"),
      },

      {
        path: "/outboundOrderPicking",
        name: "outboundOrderPicking",
        meta: {
          title: "拣货任务",
        },
        component: () =>
          import("@/views/warehouseWorkbench/OutboundOrderPicking.vue"),
      },
      {
        path: "/workbench",
        name: "workbench",
        meta: {
          title: "杂单出库",
        },
        component: () => import("@/views/warehouseWorkbench/Workbench.vue"),
      },
      {
        path: "/singleOutbound",
        name: "singleOutbound",
        meta: {
          title: "单品出库",
        },
        component: () =>
          import("@/views/warehouseWorkbench/SingleOutbound.vue"),
      },

      {
        path: "/stockList",
        name: "stock",
        meta: {
          title: "库存列表",
        },
        component: () => import("@/views/stock/StockList.vue"),
      },
      {
        path: "/positionStock",
        name: "position-stock",
        meta: {
          title: "货位库存",
        },
        component: () => import("@/views/stock/PositionStock.vue"),
      },
      {
        path: "/stockLog",
        name: "stock-log",
        meta: {
          title: "库存日志",
        },
        component: () => import("@/views/stock/StockLog.vue"),
      },
      {
        path: "/order",
        name: "order",
        meta: {
          title: "订单列表",
        },
        component: () => import("@/views/order/OrderList.vue"),
      },
      {
        path: "/afterOrder",
        name: "after-order",
        meta: {
          title: "售后订单列表",
        },
        component: () => import("@/views/order/AfterOrderList.vue"),
      },
      {
        path: "/pdaVersion",
        name: "pda-version",
        meta: {
          title: "PDA版本库",
        },
        component: () => import("@/views/system/PdaVersion.vue"),
      },
      {
        path: "/monitor",
        name: "monitor",
        meta: {
          title: "超卖监控",
        },
        component: () => import("@/views/oversold/Monitor.vue"),
      },
      {
        path: "/orderSales",
        name: "order-sales",
        meta: {
          title: "订单销售对账",
        },
        component: () => import("@/views/reconciliation/OrderSales.vue"),
      },

      {
        path: "/comparisonPrice",
        name: "comparison-price",
        meta: {
          title: "商品比价",
        },
        component: () => import("@/views/goods/ComparisonPrice.vue"),
      },
    ],
    component: () => import("@/views/Layout.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("@/views/Login.vue"),
  },
];

const router = new VueRouter({
  // mode: 'history',
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 路由前置守卫
router.beforeEach((to, from, next) => {
  if (
    to.path != "/home" &&
    to.path != "/login" &&
    to.path != "/redirect" &&
    to.path
  ) {
    store.commit("addVisitedRoute", to);
  }
  next(); // 默认放行
});

export default router;
